import r from "../managers/braze-instance.js";
import yt from "./utils/push-utils.js";
export function isPushPermissionGranted() {
  if (r.rr()) return yt.isPushPermissionGranted();
}